export default {
  app: {
    orgCode: "Nomor Grup/Merek",
    orgCodePlaceholder: "Silakan masukkan Nomor Grup/Merek",
    username: "Akaun",
    usernamePlaceholder: "Silakan masukkan akun",
    password: "sandi",
    passwordPlaceholder: "Silakan masukkan sandi",
    captcha: "Kode verifikasi",
    captchaPlaceholder: "Silakan masukkan kode verifikasi",
    captchaExpired: "Silakan refresh kode verifikasi",
    login: "Login",
    remember: "Ingat informasi daftar masuk",
    switchPC: "Beralih ke bagian belakang",
    mobileVersion: "BI Seluler",
    desktopVersion: "Backend Pedagang",
    setupPassword: "Mengatur kata sandi",
    newPassword: "kata sandi baru",
    newPasswordPlaceholder: "Silakan masukkan kata sandi baru",
    retypePassword: "Masukkan kata sandi baru lagi",
    retypePasswordPlaceholder: "Silakan masukkan kata sandi baru lagi",
    setupPasswordRule: "Kata sandi harus terdiri dari 6-32 karakter dan mengandung minimal dua dari berikut ini: angka, huruf, simbol.",
    setupPasswordRuleRefer: "Kata sandi harus terdiri dari 6-32 karakter dan mengandung lebih dari dua kombinasi angka, huruf, dan simbol. Silakan masukkan kembali.",
    setupPasswordOk: "Tentu",
    setupPasswordDiffer: "Kata sandi yang dimasukkan dua kali tidak konsisten, silakan masukkan kembali.",
    err_def: "Gagal masuk, silakan segarkan halaman dan coba lagi.",
    err_2000: "Galat input kode verifikasi.",
    err_2010: "Informasi login yang dimasukkan salah.",
    err_4001: "Akun ini tidak diotorisasi untuk fungsi apa pun.",
    err_4011: "Toko telah dinonaktifkan, tidak dapat masuk.",
    err_4012: "Waralaba telah dinonaktifkan, tidak dapat masuk.",
    err_4013: "Merek telah dinonaktifkan, tidak dapat masuk.",
    err_4014: "Grup telah dinonaktifkan, tidak dapat masuk.",
    err_4015: "Daerah telah dinonaktifkan dan daftar masuk tidak mungkin.",
    err_4401: "Akun ini tidak diizinkan untuk toko ini.",
    err_4402: "Akun ini tidak memiliki izin admin dan tidak bisa mendapatkan kode verifikasi.",
    err_5001: "Penetapan kata sandi gagal, silakan coba lagi.",
  },
  verifyRefund: {
    title: "Permintaan Pengembalian",
    hint: "Harap verifikasi informasi pengembalian sebelum beri kode.",
    verifyCode: "Kode verifikasi",
    copy: "Salin",
    copySucceed: "Berhasil Disalin.",
    copyFailed: "Gagal Disalin.",
    expireTime: "Waktu Kedaluwarsa",
    shop: "Toko",
    soTime: "Waktu Pemesanan",
    soNo: "Nomor pesanan POS",
    amount: "Jumlah Pengembalian",
  },
}